import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LaunchDialogService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { GlobalMessageService, GlobalMessageType } from '../../../../../core/global-message';
import { BaseAbstractModalComponent, ModalCloseReason } from '../../../../../core/modal';
import { ShoppingListFacade } from '../../../../../core/user';
import { BlobService } from '../../../../../shared/services/blob/blob.service';

export interface ExportShoppingListModalData {
  shoppingListCode: string;
  shoppingListName: string;
}
@Component({
  selector: 'py-export-shopping-list-modal',
  templateUrl: './export-shopping-list-modal.component.html',
  styleUrls: ['./export-shopping-list-modal.component.scss'],
})
export class ExportShoppingListModalComponent extends BaseAbstractModalComponent implements OnInit, OnDestroy {
  shoppingListCode: string;
  shoppingListName: string;

  exportingAsPdf = false;
  exportingAsXlsx = false;

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    displayPrices: new UntypedFormControl(true),
  });

  private subscriptions = new Subscription();

  constructor(
    private shoppingListService: ShoppingListFacade,
    private blobService: BlobService,
    private globalMessageService: GlobalMessageService,
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
    protected renderer: Renderer2
  ) {
    super(el, launchDialogService, renderer);
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.launchDialogService.data$.pipe(take(1)).subscribe((data: ExportShoppingListModalData) => {
        this.shoppingListCode = data.shoppingListCode;
        this.shoppingListName = data.shoppingListName;
      })
    );
  }

  onExportPdf(): void {
    this.exportingAsPdf = true;
    this.subscriptions.add(
      this.shoppingListService
        .exportShoppingListAsPdf(this.shoppingListCode, this.formGroup.get('displayPrices').value)
        .pipe(
          finalize(() => {
            this.exportingAsPdf = false;
            this.launchDialogService.closeDialog(ModalCloseReason.EXPORT_SHOPPING_LIST_SUCCESS);
          })
        )
        .subscribe(
          (blob) => this.blobService.download(`${this.exportFileName}.pdf`, blob),
          () => this.handleExportError()
        )
    );
  }

  onExportXlsx(): void {
    this.exportingAsXlsx = true;
    this.subscriptions.add(
      this.shoppingListService
        .exportShoppingListAsXlsx(this.shoppingListCode, this.formGroup.get('displayPrices').value)
        .pipe(
          finalize(() => {
            this.exportingAsXlsx = false;
            this.launchDialogService.closeDialog(ModalCloseReason.EXPORT_SHOPPING_LIST_SUCCESS);
          })
        )
        .subscribe(
          (blob) => this.blobService.download(`${this.exportFileName}.xlsx`, blob),
          () => this.handleExportError()
        )
    );
  }

  get exportFileName(): string {
    return this.shoppingListName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private handleExportError(): void {
    this.globalMessageService.add({ key: 'shoppingLists.errorDuringExport_message' }, GlobalMessageType.MSG_TYPE_ERROR, 3000);
  }
}
